import React from "react";
import Table from "../Table";
import moment from "moment";
import { Link } from "react-router-dom";
import { isEmpty, startCase } from "lodash-es";
import { Fulfillment } from "@secondcloset/types";
import { useQuery } from "react-query";
import { fetchASNIndex, FetchASNQuery } from "../../../../../api/fulfillment/asn";

interface ASNTableProps {
  query: FetchASNQuery;
}

const ASNTable: React.FC<ASNTableProps> = ({ query }) => {
  const organizationID = query.organization_id;

  const ASNIndex = useQuery(["ASNIndex", query], () => fetchASNIndex(query), {
    enabled: !isEmpty(query),
  });

  const getASNColumns = () => {
    const renderID = (id: string, asn: Fulfillment.ASN) => (
      <Link
        className="asn-id-cell"
        to={{
          pathname: `/fulfillment/asns/${id}`,
          state: { organizationID },
        }}
      >
        {asn.number}
      </Link>
    );

    const renderArrivalDate = (expected_arrival_date: string, { actual_arrival_date }: Fulfillment.ASN) => {
      const date = actual_arrival_date ?? expected_arrival_date;
      return date ? moment(date).format("ll") : "-";
    };

    const renderCreateDate = (_: string, { created_at }: Fulfillment.ASN) => {
      return created_at ? moment(created_at).format("ll") : "-";
    };

    return [
      { title: "ASN ID", dataIndex: "id", render: renderID, key: "id" },
      {
        title: "Creation Date",
        dataIndex: "created_at",
        key: "created_at",
        render: renderCreateDate,
      },
      {
        title: "Arrival Date",
        dataIndex: "expected_arrival_date",
        key: "expected_arrival_date",
        render: renderArrivalDate,
      },
      {
        title: "Warehouse",
        dataIndex: "facility",
        key: "facility",
        render: (f?: string) => f || "-",
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        render: (status: string) => startCase(status),
      },
    ];
  };

  const title = "Advance Shipping Notice";
  const fullListLink = `/organizations/${organizationID}/asns`;
  const columns = getASNColumns();

  return (
    <div className="fulfillment-table">
      <Table
        headerButtons={[]}
        tableProps={{
          columns,
          dataSource: ASNIndex.data,
          loading: ASNIndex.isLoading,
        }}
        title={title}
        fullListLink={fullListLink}
      />
    </div>
  );
};

export default ASNTable;
